import { createSlice, current } from "@reduxjs/toolkit";

import { set } from "react-hook-form";

const initialState = {
	notebookList: [],
	currentNotebook: null,
};

const notebookSlice = createSlice({
	name: "notebook",
	initialState,
	reducers: {
		setNotebookList: (state, action) => {
			state.notebookList = action.payload;
		},
		addNotebook: (state, action) => {
			state.notebookList.unshift(action.payload);
			state.currentNotebook = state.notebookList[0].NOTEBOOK_ID
		},
		setNotebook: (state, action) => {
			state.currentNotebook = action.payload;
		},
	},
});

export const { setNotebookList, addNotebook, setNotebook } = notebookSlice.actions;

export default notebookSlice.reducer;
